import { render, staticRenderFns } from "./EditImagemHome.vue?vue&type=template&id=448da14c&scoped=true&"
import script from "./EditImagemHome.vue?vue&type=script&lang=js&"
export * from "./EditImagemHome.vue?vue&type=script&lang=js&"
import style0 from "./EditImagemHome.vue?vue&type=style&index=0&id=448da14c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448da14c",
  null
  
)

export default component.exports